let hero = {};
let last_known_scroll_position = 0;
let ticking = false;
let count = 0;
let wasBodyPost = false;
// import CircleType from 'circletype';

hero.init = () => {
  last_known_scroll_position = window.scrollY;
  count++;
  if (!ticking) {
    window.requestAnimationFrame(function () {
      hero.action(last_known_scroll_position);
      ticking = false;
    });

    ticking = true;
  }
}

hero.action = (scroll_pos) => {
  let countFinal = (count / 10);
  let ele = document.getElementsByClassName('js-hero-mouse');

  for (let i = 0; i < ele.length; i++) {
    if (!ele) return;

    if (scroll_pos > 0) {
      if (wasBodyPost) {
        ele[i].style.opacity = 1 - countFinal;
        ele[i].style.opacity = 0;
      }
      wasBodyPost = true;
    } else if (scroll_pos < 5) {
      count = 0;
      wasBodyPost = false;
      if (!wasBodyPost) {
        ele[i].style.opacity = 0 + countFinal;
      }
    }
  }
}

hero.bodyPost = () => {
  let top = window.pageYOffset || document.documentElement.scrollTop;
  let ele = document.getElementsByClassName('js-hero-mouse');
  for (let i = 0; i < ele.length; i++) {
    if (!ele) return;

    if (top > 0) {
      ele[i].style.opacity = 0;
      wasBodyPost = true;
    } else if (top < 5) {
      count = 0;
      ele[i].style.opacity = 1;
      wasBodyPost = false;
    }
  }
}

// hero.curveTitle = () => {

//   var demo5 = new CircleType(document.getElementById('demo1'))
//     .radius(350);
//   $(demo5.element).fitText();


// };

var $curvedText = $(".js-title-curved");


hero.updateCurvedText = ($curvedText, radius)  => {
  $curvedText.css("min-width", "initial");
  $curvedText.css("min-height", "initial");
  var w = $curvedText.width(),
    h = $curvedText.height();
  $curvedText.css("min-width", w + "px");
  $curvedText.css("min-height", h + "px");
  var text = $curvedText.text();
  var html = "";

  Array.from(text).forEach(function (letter) {
    html += `<span>${letter}</span>`;
  });
  $curvedText.html(html);

  var $letters = $curvedText.find("span");
  $letters.css({
    position: "absolute",
    height:`${radius}px`,
    // backgroundColor:"orange",
    transformOrigin:"bottom center"
  });

  var circleLength = 2 * Math.PI * radius;
  var angleRad = w/(2*radius);
  var angle = 2 * angleRad * 180/Math.PI/text.length;

  $letters.each(function(idx,el){
    $(el).css({
        transform:`translate(${w/2}px,0px) rotate(${idx * angle - text.length*angle/2}deg)`
    })
  });
}


// hero.settingsChanged = ()  => {
//   $curvedText.text($(".js-text").val());
//   hero.updateCurvedText($curvedText,$(".js-radius").val());
// }


document.addEventListener('DOMContentLoaded', function (event) {


  // hero.updateCurvedText($curvedText,320);
  hero.updateCurvedText($curvedText,270);

  // $(".js-radius").on("input change",hero.settingsChanged);
  // $(".js-text").on("input change",hero.settingsChanged);

  // hero.curveTitle();

  if (window.innerWidth > 768) {
    window.addEventListener("scroll", hero.init);
    hero.bodyPost();
  }

  window.addEventListener('resize', () => {
    hero.updateCurvedText($curvedText,270);

    if (window.innerWidth > 768) {
      window.addEventListener("scroll", hero.init);
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/components/hero.js